export default {
  serverapi:
    process.env.NODE_ENV === 'development'
      ? 'http://127.0.0.1:9006/v1/'
      : 'https://admin.api.taisam.cn/v1/',
  env: process.env,
}
